<template>
  <section class="space-info flex ml-4 border-orange border-1 rounded p-1 bg-white" :class="{'border-3': md, 'p-2': md, 'md-width': md}">
    <div v-if="hasFreeSpaceInfo" class="availability">
      <div class="text-2xs font-bold text-secondary" :class="{'text-sm': md}">
        {{ freeSpace.effectivePeriod }}
      </div>
      <div v-if="freeSpace.spaceAvailable <= 1000" class="whitespace-no-wrap">
        <span class="text-base font-bold text-header" :class="{'text-xl': md }">{{ freeSpace.spaceAvailable }}</span>
        <span class="text-2xs" :class="{'text-sm': md}">{{ $t('warehouse.tsuboAvailable') }}</span>
      </div>
      <div v-else class="whitespace-no-wrap">
        <span class="text-base font-bold text-header">1000</span>
        <span class="text-2xs text-header">{{ $t('warehouse.tsubo') }}{{ $t('warehouse.greaterThan' ) }}</span>
      </div>
    </div>
    <div v-else class="availability">
      <div class="text-2xs font-bold text-header">{{ $t('warehouse.freeSpaceInfo') }}</div>
      <div class="text-base font-bold text-header">{{ $t('warehouse.inquire') }}</div>
    </div>
  </section>
</template>

<style lang="sass" scoped>
.md-width
  width: 120px
</style>
<script>
import { getToday, convertToDate, formatDate, addMonths } from '@/components/utils/date';
import { freeSpaceDisplayMap } from '@/model/warehouse';
export default {
  props: {
    freeSpaces: { type: Array, required: true },
    md: { type: Boolean, default: false}
  },
  computed: {
    hasFreeSpaceInfo () {
      return !(this.freeSpace === null);
    },
    freeSpace () {
      const defaultFs = this.freeSpaces.find(fs => Boolean(fs));
      if (!defaultFs) return null;

      const { effective_at: effectiveAt, free_space: freeSpace } = defaultFs;
      const today = getToday().getTime();
      const dateEffective = convertToDate(effectiveAt).getTime();
      const expiringDate = addMonths(dateEffective, 3).getTime();
      // freeSpace is bigger than 0-50 tsubo (unknown is -1)
      //  within effectiveAt includes today to 3 months later (expiringDate) if the effective date is current
      //   OR the future date
      if (freeSpace >= 0 && ((dateEffective <= today && today <= expiringDate) || dateEffective > today)) {
        return {
          effectivePeriod: dateEffective > today ? `${formatDate(dateEffective)} ~` : this.$t('warehouse.currentlyAvailable'),
          spaceAvailable: freeSpaceDisplayMap[freeSpace]
        };
      } else return null;
    },
  }
};
</script>
